import appInvoice from "../../views/appPlans/invoice.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("invoice", {
    url: "invoice/:id",
    parent: "app",
    views: {
      view: {
        template: appInvoice,
      },
    },
    reloadOnSearch: false,
    data: { title: "Invoice" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/invoice/invoice.urls.js